import React from 'react'
import { UserMenu } from '../Header/UserMenu'
import { AlertBell } from '@/components/Alerts/AlertBell'
import { ThemeToggle } from '../Header/ThemeToggle'

export const TopBar: React.FC = () => {
  return (
    <div
      className="flex items-center justify-end gap-6 px-6 backdrop-blur-sm"
      style={{
        height: 64,
        borderBottom: '1px solid var(--border)',
        background: 'color-mix(in srgb, var(--bg-card) 85%, transparent)',
        boxShadow: 'var(--shadow-sm)'
      }}
    >
      <div className="flex items-center gap-4">
        <ThemeToggle />
        <AlertBell />
        <UserMenu />
      </div>
    </div>
  )
}
